<template>
  <div v-if="visible" class="login-dialog-mask">
    <div class="login-dialog">
      <h3 class="login-title">手机号登录</h3>
      <div v-if="errorMsg" class="login-error">{{ errorMsg }}</div>
      <input
        v-model="phone"
        type="tel"
        maxlength="11"
        placeholder="请输入手机号"
        class="login-input"
        @input="onPhoneInput"
      />
      <div class="login-code-row">
        <input
          v-model="code"
          type="text"
          maxlength="6"
          placeholder="请输入验证码"
          class="login-input code-input"
        />
        <button
          class="code-btn"
          :disabled="!canSendCode"
          @click="sendCode"
        >{{ codeBtnText }}</button>
      </div>
      <button
        class="login-btn"
        :disabled="!canLogin"
        @click="login"
      >登录</button>
      <span class="login-close" @click="close">×</span>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { http } from '@/utils/http';
import jsCookie from 'js-cookie';

export default {
  name: 'MobileLoginDialog',
  data() {
    return {
      visible: false,
      phone: '',
      code: '',
      errorMsg: '',
      codeBtnText: '获取验证码',
      codeTimer: 0,
      codeCountdown: 60,
      sending: false,
    };
  },
  computed: {
    phoneValid() {
      return /^1\d{10}$/.test(this.phone);
    },
    codeValid() {
      return /^\d{6}$/.test(this.code);
    },
    canSendCode() {
      return this.phoneValid && this.codeTimer === 0 && !this.sending;
    },
    canLogin() {
      return this.phoneValid && this.codeValid;
    },
  },
  methods: {
    onPhoneInput() {
      if (this.phone.length > 11) this.phone = this.phone.slice(0, 11);
    },
    sendCode() {
      if (!this.phoneValid) return;
      this.sending = true;
      http.post('/api/cmcc/migu_sf/login/sendCode', { phone: this.phone })
        .then(() => {
          this.sending = false;
          this.codeTimer = this.codeCountdown;
          this.startTimer();
          this.$toast && this.$toast('验证码已发送');
        })
        .catch(() => {
          this.sending = false;
          this.$toast && this.$toast('验证码发送失败');
        });
    },
    startTimer() {
      if (this.codeTimer > 0) {
        this.codeBtnText = `${this.codeTimer}s`;
        setTimeout(() => {
          this.codeTimer--;
          this.startTimer();
        }, 1000);
      } else {
        this.codeBtnText = '获取验证码';
      }
    },
    login() {
      if (!this.canLogin) return;
      this.errorMsg = '';
      http.post('/api/cmcc/migu_sf/login/sms', { phone: this.phone, code: this.code })
        .then(res => {
          if (res.code === 0 && res.data && res.data.loginUrl) {
            this.visible = false;
            window.location.href = res.data.loginUrl;
          } else {
            this.errorMsg = res.msg || '登录失败';
          }
        })
        .catch(() => {
          this.errorMsg = '登录失败';
        });
    },
    close() {
      this.visible = false;
      this.errorMsg = '';
    },
  },
};
</script>

<style scoped>
.login-dialog-mask {
  position: fixed;
  left: 0; top: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.4);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.login-dialog {
  background: #fff;
  border-radius: 8px;
  padding: 32px 24px 24px 24px;
  min-width: 300px;
  position: relative;
  box-shadow: 0 2px 16px rgba(0,0,0,0.15);
}
.login-title {
  margin-bottom: 18px;
  font-size: 18px;
  text-align: center;
}
.login-error {
  color: #f56c6c;
  font-size: 14px;
  text-align: center;
  margin-bottom: 12px;
}
.login-input {
  width: 100%;
  padding: 8px 12px;
  margin-bottom: 14px;
  border: 1px solid #eee;
  border-radius: 4px;
  font-size: 16px;
  box-sizing: border-box;
}
.login-code-row {
  display: flex;
  align-items: center;
  margin-bottom: 14px;
}
.code-input {
  flex: 1;
  margin-right: 8px;
}
.code-btn {
  padding: 8px 12px;
  border: none;
  background: #409eff;
  color: #fff;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
}
.code-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
}
.login-btn {
  width: 100%;
  padding: 10px 0;
  background: #409eff;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
}
.login-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
}
.login-close {
  position: absolute;
  right: 12px;
  top: 8px;
  font-size: 22px;
  color: #aaa;
  cursor: pointer;
}
</style>
